import styled from 'styled-components';

export const SplitLabelTextContainer = styled.div`
  display: inline-flex;
  gap: 3px;
`;
